import { scrapeProbabilityCalculator } from '../utils/scrape-probability';

type ValidHttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

export interface HttpRequest extends RequestInit {}

class HttpRequestBuilder {
  private _method: ValidHttpMethod = 'GET';

  private _headers: { [key: string]: string } = {};

  private _body: any = null;

  private _credentials?: RequestCredentials = undefined;

  public accept(acceptHeader: string) {
    this._headers.Accept = acceptHeader;
    return this;
  }

  public token(token: string) {
    this._headers.Authorization = `Bearer ${token}`;
    return this;
  }

  public method(method: ValidHttpMethod) {
    this._method = method;
    return this;
  }

  public content(body: any, contentType: string | null = 'application/json') {
    if (body) {
      switch (contentType) {
        case 'application/json':
          this._body = JSON.stringify(body);
          break;
        default:
          this._body = body;
          break;
      }
    }

    if (contentType) {
      this._headers['Content-Type'] = contentType;
    }

    return this;
  }

  public scrapeProbabilityScore(scrapeProbabilityScore?: boolean) {
    if (scrapeProbabilityScore) {
      const probabilityScore = scrapeProbabilityCalculator();
      this._headers['x-scrape-probability'] = `${probabilityScore}`;
    }
    return this;
  }

  public withCookies(withCookies: boolean) {
    if (withCookies) {
      this._credentials = 'same-origin';
    }
    return this;
  }

  public build(): HttpRequest {
    return {
      body: this._body,
      headers: this._headers,
      method: this._method,
      credentials: this._credentials,
    };
  }
}

export default HttpRequestBuilder;
